<template>
  <v-container>
    <v-row>
      <v-col class="d-flex align-center" :class="{ 'mt-3': !hideLink }">
        <v-img
          v-if="entry.icon"
          class="mr-1"
          :src="`${publicPath}icons/${entry.icon}`"
          :alt="entry.name"
          max-width="28"
        />
        <h2 class="primary--text font-weight-bold">
          <item-string :qualities="entry.Qualities">{{ entry.name }}</item-string>
        </h2>
        <p class="mb-n1 ml-2">({{ entry.ItemType.name }})</p>
        <v-btn
          v-if="!hideLink"
          :to="{ name: 'Consumable', params: { slug: entry.name.toLowerCase().replace(/-/g, '§-').replace(/ /g, '-') } }"
          icon
        >
          <v-icon color="primary">
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <v-row no-gutters v-if="entry.potionEffByClass.length">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Potion Efficiency by Class</v-subheader>
      </v-col>
      <v-col lg="12" style="white-space: pre-line;">
        {{ entry.potionEffByClass.map(p => `${p.name}: ${p.ItemPotionEffByClass.potionEff}`).join('\n') }}
      </v-col>
    </v-row>
    <v-row no-gutters v-if="entry.properties">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Description</v-subheader>
      </v-col>
      <v-col lg="12" style="white-space: pre-line;">
        {{ entry.properties }}
      </v-col>
    </v-row>
    <v-row no-gutters v-if="entry.HoradricCubes.length">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Horadric Cube Recipes</v-subheader>
      </v-col>
      <v-col lg="12">
        <v-chip
          v-for="(pre, i) in entry.HoradricCubes" :key="`cube-recipe-${entry.id}-${i}`"
          class="mr-2 mb-1"
          outlined
          :to="{ name: 'HoradricCubeRecipe', params: { slug: `${pre.id}-${pre.result.toLowerCase().replace(/-/g, '§-').replace(/ /g, '-')}` } }"
        >
          {{ pre.result }}
        </v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ItemString from './ItemString'

export default {
  name: 'DetailedConsumable',
  components: {
    ItemString
  },
  props: {
    entry: Object,
    hideLink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>
